import React from 'react';

function Instagram({ size = 18, stroke = 'currentColor', strokeWidth = 1.3, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      {...otherProps}
    >
      <rect x="0.65" y="0.65" width="20.7" height="20.7" rx="5.35" />
      <circle cx="11" cy="11" r="4.35" />
      <circle r="1" transform="matrix(-1 0 0 1 17 5)" />
    </svg>
  );
}

export default Instagram;
